import { Heart, Check, Mail, Phone, Shield, Instagram, Facebook, Twitter } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-white mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <span className="relative inline-flex items-center justify-center h-7 w-7">
              <Heart className="h-7 w-7 text-brand-gold" fill="#C5A059" strokeWidth={1.2} />
              <Check className="absolute h-3.5 w-3.5 text-brand-ink" strokeWidth={3.2} style={{ top: "44%", left: "50%", transform: "translate(-50%, -50%)" }} />
            </span>
            <span className="font-serif text-3xl text-white tracking-wide">Right<span className="italic text-brand-gold"> Match</span></span>
          </div>
          <p className="text-sm text-white/70 max-w-sm leading-relaxed">
            The world&apos;s most trusted South Asian matchmaking platform. Connecting hearts across India, Pakistan, Bangladesh, the UK, USA and Canada — verified profiles, curated matches, lifelong bonds.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" className="p-2 rounded-full border border-white/20 hover:border-brand-gold hover:text-brand-gold transition-colors"><Instagram className="h-4 w-4" /></a>
            <a href="#" className="p-2 rounded-full border border-white/20 hover:border-brand-gold hover:text-brand-gold transition-colors"><Facebook className="h-4 w-4" /></a>
            <a href="#" className="p-2 rounded-full border border-white/20 hover:border-brand-gold hover:text-brand-gold transition-colors"><Twitter className="h-4 w-4" /></a>
          </div>
        </div>

        <div>
          <p className="overline mb-4 text-brand-gold">Platform</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/register" className="hover:text-brand-gold">Register Free</Link></li>
            <li><Link to="/search" className="hover:text-brand-gold">Find Matches</Link></li>
            <li><Link to="/plans" className="hover:text-brand-gold">Membership</Link></li>
            <li><Link to="/login" className="hover:text-brand-gold">Sign in</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-brand-gold">Trust</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-center gap-2"><Shield className="h-3 w-3" /> Verified profiles</li>
            <li>Privacy controls</li>
            <li>Background checks</li>
            <li>24x7 support</li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-brand-gold">Contact</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-center gap-2"><Mail className="h-3 w-3" /> help@rightmatch.ca</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50">
          <p>© 2026 Right Match Matrimony. All rights reserved.</p>
          <p>Crafted with care for the global South Asian diaspora 🌍</p>
        </div>
      </div>
    </footer>
  );
}
